import Game from "./Game";

let User:any = {
    Init: function(callback:Function){
        //TODO: reimplement as react
        // $.post("/Login/User", function(user){
        //     User.user = $.parseJSON(user);
        //     // Attributes: id, email, first_name, gender, link, name, userAgent, username
        //
        //     callback();
        // });
    },
    Invite: function(userid:any, callback:Function){
        //TODO: reimplement as react
        // $.post("/User/Invite", {id: userid}, function(user){
        //     //User.user = $.parseJSON(user);
        //     // Attributes: id, email, first_name, gender, link, name, userAgent, username
        //
        //     if (callback){
        //         callback();
        //     }
        // });
    },
    Accept: function(userid:any, callback:Function){
        //TODO: reimplement as react
        // $.post("/User/Accept", {id: userid}, function(user){
        //
        //     if (callback){
        //         callback();
        //     }
        // });
    },
    SaveShot: function(){
        //TODO: reimplement as react
        // $.post("/User/SaveFirstShot", {shotTime: User.user.firstShotTime}, function(){
        //
        // });
    },
    GetOpponent: function(){
        return null; // multiplayer opponents are handled by Match.ts
    }
};

export default User;